import devapis from "./dev.endpoints";
import stagingapis from "./staging.endpoints";
import prodapis from "./prod.endpoints";
const localtodev = "http://localhost:3000,http://localhost:3001,";
const localtostage = "";
const localtoprod = "";

export const endpoints = {
    "dev": {
        "base": `${localtodev}https://devportal.wealthavenue.in`,
        "api_base": "https://devapi.wealthavenue.in",
        "static_token": "",
        ...devapis,
        "open/login": {
            "base": `${localtodev}https://devportal.wealthavenue.in`,
            "api_base": "https://devapi.wealthavenue.in",
            ...devapis,
        },
    },
    "staging": {
        "base": `${localtostage}https://lmsstage.impetusaisolutions.com`,
        "api_base": "https://lmsapistage.impetusaisolutions.com",
        "static_token": "",
        ...stagingapis,

        "open/login": {
            "base": "https://lmsstage.impetusaisolutions.com",
            "api_base": "https://lmsapistage.impetusaisolutions.com",
            ...stagingapis,
        },
    },
    "production": {
        "base": `${localtoprod}https://portal.wealthavenue.in`,
        "api_base": "https://api.wealthavenue.in",
        "static_token": "",
        ...prodapis,

        "open/login": {
            "base": "https://portal.wealthavenue.in",
            "api_base": "https://api.wealthavenue.in",
            ...prodapis,
        },
    }
}

export default endpoints;